// HealthRiskAssessmentModal.tsx
import {
    Modal,
    Text,
    Radio,
    Stack,
    Button,
    Group,
    Divider,
    Box,
  } from "@mantine/core";
  
  interface Props {
    opened: boolean;
    onClose: () => void;
  }
  
  export function HealthRiskAssessmentModal({ opened, onClose }: Props) {
    return (
      <Modal
        opened={opened}
        onClose={onClose}
        centered
        size="lg"
        padding="xl"
        radius="md"
        overlayProps={{ opacity: 0.2, blur: 2 }}
        styles={{
          header: {
            borderBottom: "1px solid #edf0f2",
            paddingBottom: 12,
            marginBottom: 16,
          },
          body: {
            paddingTop: 8,
          },
        }}
        title={
          <Text fw={600} size="lg">
            Health Risk Assessment
          </Text>
        }
      >
        <Stack gap="md">
          <Text fw={600} size="lg">
            Question 1
          </Text>
  
          <Text size="sm" c="dimmed">
            What is considered a normal blood pressure reading for adults?
          </Text>
  
          <Radio.Group>
            <Stack gap="sm">
              <Radio value="1" label="150/90 mmHg" />
              <Radio value="2" label="120/80 mmHg" />
              <Radio value="3" label="100/60 mmHg" />
              <Radio value="4" label="140/100 mmHg" />
            </Stack>
          </Radio.Group>
  
          <Divider mt="md" />
  
          <Group justify="space-between">
            <Button variant="subtle" color="gray">
              Previous
            </Button>
  
            <Box
              style={{
                background: "#f1f3f5",
                padding: "6px 14px",
                borderRadius: 8,
                fontWeight: 500,
                fontSize: 14,
              }}
            >
              1/4
            </Box>
  
            <Button>Next</Button>
          </Group>
        </Stack>
      </Modal>
    );
  }
  